import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoginService } from 'src/app/services/auth/login/login.service';
import { EventStatusService } from 'src/app/services/events/eventStatus/event-status.service';
import { UpdateEventStatusService } from 'src/app/services/events/updateEventStatus/update-event-status.service';

declare var $: any
@Component({
  selector: 'app-room-approval',
  templateUrl: './room-approval.component.html',
  styleUrls: ['./room-approval.component.less']
})
export class RoomApprovalComponent implements OnInit {

  @Input('details') details: any;
  @Output() bookedData = new EventEmitter();

  public statusData: any = []
  public skeletonLader: Boolean = true
  public submitLoading: boolean = false

  public formData: any = {
    status: '',
    amount: '',
    remarks: ''
  }

  constructor(
    private EventStatusService: EventStatusService,
    private UpdateEventStatusService: UpdateEventStatusService,
    private LoginService: LoginService
  ) { }

  ngOnInit() {
  }

  async roomStatus(data, patchValue?) {
    this.skeletonLader = true
    if (patchValue) {
      this.formData = {
        status: true,
        amount: patchValue.room_amount,
        remarks: patchValue.admin_remarks
      }

    }
    // this.myForm.control.setValue({name: this.name});
    $("#roomStatus").modal("show");
    this.details = data
    let root = this
    setTimeout(function () {
      root.skeletonLader = false
    }, 95)
  }


  async changeRoomStatus(val) {
    this.submitLoading = true
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()

    let data = {
      "partner_id": this.details.partner_id,
      "full_name": this.details.full_name,
      "email_id": this.details.email_id,
      "primary_mobile_no": this.details.primary_mobile_no,
      "event_reg_id": parseInt(this.details.event_reg_id),
      "event_id": parseInt(this.details.event_id),
      "approval_status": val.status ? 1 : 0,
      "user_id": parseInt(user_id.STAFF_ID),
      "remarks": val.remarks,
      "amount": val.amount
    }
    let result = await this.UpdateEventStatusService.updateRoomStatus(data)
    console.log(result)
    if (result.status == "success") {
      this.bookedData.emit({
        is_approved: val.status,
        room_amount: val.amount,
        admin_remarks: val.remarks
      });
      this.submitLoading = false
      $("#roomStatus").modal("hide");
    } else {
      this.submitLoading = false
    }
  }


}
